<template>
<div class="chapter">
<div class="inner_page">
<h1 class="parttitle">PART ONE</h1>
<h1 class="parttitle">HOW TO PLAN, LEAD, AND MANAGE OUTSOURCING INITIATIVES</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?58904747